import { render, staticRenderFns } from "./UkFrontOfPackConfiguration.vue?vue&type=template&id=2679d6a8&scoped=true"
import script from "./UkFrontOfPackConfiguration.vue?vue&type=script&setup=true&lang=ts"
export * from "./UkFrontOfPackConfiguration.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./UkFrontOfPackConfiguration.vue?vue&type=style&index=0&id=2679d6a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2679d6a8",
  null
  
)

export default component.exports